import BUSINESS_USER_TYPE from './businessUserType.gql';
import CIVIL_STATUSES from './civilStatuses.gql';

export {
  BUSINESS_USER_TYPE,
  CIVIL_STATUSES,
};
